














import { defineComponent } from "@vue/composition-api";
import { TabField } from "@/types";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "TabsHeader",
  components: { SiteLogo },
  props: {
    tabs: { type: Array as () => TabField[], required: true },
    active: { type: String },
  },
});
